export const formatDurationFromSeconds = (
  seconds: number | null | undefined,
  subMinuteDecimals = 0
): string => {
  if (seconds == null || isNaN(seconds)) {
    return '–';
  }
  // Round to the display precision before branching so a value that rounds up
  // to the minute takes the minute path (59.7s → "1m", never "60s").
  const factor = 10 ** subMinuteDecimals;
  const rounded = Math.round(seconds * factor) / factor;
  if (rounded < 60) {
    return `${rounded.toFixed(subMinuteDecimals)}s`;
  }
  const total = Math.round(seconds);
  if (total >= 3600) {
    const hours = Math.floor(total / 3600);
    const mins = Math.floor((total % 3600) / 60);
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  }
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
};
